import React from 'react'
import { ToastContainer } from 'react-toastify'

import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

import GlobalStyle from '~/commons/styles/global'
import { CartProvider } from '~/contexts/cart'

import 'react-toastify/dist/ReactToastify.css'

function Ubertrans({ children, theme }) {
  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyle />
        <CartProvider>{children}</CartProvider>
        <ToastContainer />
      </ThemeProvider>
    </MuiThemeProvider>
  )
}

Ubertrans.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
}

export default Ubertrans
